/* Copyright 2013 - 2024 Waiterio LLC */
import colorPrimary from './colorPrimary.js'

export default `

  :root {
    --color-primary: ${colorPrimary};
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  body, html {
    height: 100%;
    width: 100%;
    margin: 0;
    outline: 0;
    color: #626262;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: #626262;
  }

  body, html, button {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,Cantarell,'Fira Sans','Droid Sans','Helvetica Neue',Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol';
  }

  a {
    color: inherit;
  }

  a:hover {
    color: black;
  }

  img {
    width: 100%;
  }

  #root:not(:empty) {
    width: 100%;
    height: 100%;
  }

  .loader:empty {

    top: 50%;
    margin: 0px auto;
    transform: translateY(-50%);

    border-radius: 50%;
    width: 7em;
    height: 7em;

    font-size: 5px;
    position: relative;
    text-indent: -9999em;
    border-top: 1.1em solid rgba(0, 0, 0, 0.2);
    border-right: 1.1em solid rgba(0, 0, 0, 0.2);
    border-bottom: 1.1em solid rgba(0, 0, 0, 0.2);
    border-left: 1.1em solid rgba(98, 98, 98, 1);
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: rotation 1.1s infinite linear;
    animation: rotation 1.1s infinite linear;
  }

  @-webkit-keyframes rotation {

    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }

  }

  @keyframes rotation {

    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }

  }

`
